import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-white text-slate-900 grid place-items-center font-heading font-bold text-lg">S</div>
            <div className="font-heading text-white text-lg font-semibold">Solutions Showroom</div>
          </div>
          <p className="mt-4 text-slate-400 max-w-md leading-relaxed">
            A centralized showroom of enterprise-ready systems. Browse, demo, and partner with us to deploy production-grade software faster.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">Explore</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors">All Systems</Link></li>
            <li><a href="/#categories" className="hover:text-white transition-colors">Categories</a></li>
            <li><a href="/#featured" className="hover:text-white transition-colors">Featured</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">For Partners</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><a href="/#contact" className="hover:text-white transition-colors">Request Customization</a></li>
            <li><a href="/#contact" className="hover:text-white transition-colors">Schedule Demo</a></li>
            <li><Link to="/admin/login" className="hover:text-white transition-colors">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Solutions Showroom. All rights reserved.</div>
          <div className="mt-3 md:mt-0">For evaluation purposes only — demo credentials are sandbox-only.</div>
        </div>
      </div>
    </footer>
  );
}
